import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { STATUS_OBJECT } from "src/app/dummy/status";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthStore } from "src/app/stores/auth/auth.store";
import { PrintService } from "src/app/services/print.service";
import { TABS } from "src/app/dummy/tab";
import { COLLECTION_NAME } from "src/app/dummy/app";
import { ResourceStore } from "src/app/stores/resources/resource.store";
import { MatDialog, MatSnackBar } from "@angular/material";
import { DeleteComponent } from "src/app/components/delete/delete.component";
import { Subscription } from "rxjs";

@Component({
  selector: "app-lesson",
  templateUrl: "./lesson.component.html",
  styleUrls: ["./lesson.component.scss"],
})
export class LessonComponent implements OnInit {
  @ViewChild("PRINT_TABLE", { static: false }) PRINT_TABLE: ElementRef;
  tabs = TABS.LESSON;
  DISPLAY_STATUS_KEY: any;
  subscribe: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: ResourceStore,
    private auth: AuthStore,
    public ps: PrintService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) { }

  async ngOnInit() {
    if (this.subscribe) this.subscribe.unsubscribe()
    this.subscribe = this.route.params.subscribe(async (param) => {
      this.DISPLAY_STATUS_KEY = STATUS_OBJECT[param["id"]];
      const { selectedCompanyKey } = this.auth;
      this.store.fetchData(
        COLLECTION_NAME.LESSON,
        this.DISPLAY_STATUS_KEY.key,
        selectedCompanyKey
      );
    });
  }

  ngOnDestroy() {
    if (this.subscribe) this.subscribe.unsubscribe();
    const { fetchDataRef } = this.store;
    fetchDataRef && fetchDataRef.unsubscribe();
  }

  onScroll(event) {
    if (!this.store.data) return;
    if (event.endIndex !== this.store.data.length - 1) {
      return;
    }
    const { lastVisible } = this.store;
    if (!lastVisible) return;
    const { selectedCompanyKey } = this.auth;
    this.store.fetchMore(
      COLLECTION_NAME.LESSON,
      this.DISPLAY_STATUS_KEY.key,
      selectedCompanyKey
    );
  }

  async create() {
    // await this.store.fetchLessonImport();
    this.router.navigate([`/lessons/lesson-form/draft`])
  }

  edit(item: any) {
    this.router.navigate([`/lessons/lesson-form/${item.key}`]);
  }

  delete(item: any) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: item,
      panelClass: "cs-overlay-panel",
      width: "",
      height: "",
      role: "dialog",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === "yes") {
        this.store.delete(COLLECTION_NAME.LESSON, item, (success) => {
          if (success) {
            this.snackBar.open("Level has been deleted successful.", "Done", {
              duration: 2500,
            });
          }
        });
      }
    });
  }
}
